import { getImageUrl } from "helpers";

const BenefitsItem = ({ data }) => {
    const { icon, title, text } = data
    const image = getImageUrl(icon)
    return (
        <div className="benefits-item">
            <div className="benefits-item__icon ">
                <img src={image} alt="" />
            </div>
            <div className="description2">
                {title}
            </div>
            <div className="body2">{text}</div>
        </div>
    );
}

export default BenefitsItem;